import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { deleteTask } from 'bundles/apex/playbooks/config/store/playbooks/actions';

export function DeleteTask({ playbook, task, deleteTask }) {
  const onDelete = (e) => {
    e.stopPropagation();
    deleteTask(playbook, task);
  };

  return (
    <React.Fragment>
      <FontAwesomeIcon
        className="clickable"
        icon={faTrashAlt}
        onClick={onDelete}
      />
    </React.Fragment>
  );
}

DeleteTask.propTypes = {
  deleteTask: PropTypes.func.isRequired,
  playbook: PropTypes.object.isRequired,
  task: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
};

const mapDispatchToProps = {
  deleteTask
};

export default connect(null, mapDispatchToProps)(DeleteTask);

